import type { SiteContactData, SiteDetailsResponse } from '../services/copSiteDetails.service'

function toDMS(deg: number, posLabel: string, negLabel: string): string {
    const dir = deg >= 0 ? posLabel : negLabel
    const abs = Math.abs(deg)
    const d = Math.floor(abs)
    const mFull = (abs - d) * 60
    const m = Math.floor(mFull)
    const s = Math.round((mFull - m) * 60)
    return `${d}° ${m}' ${s}" ${dir}`
}

export function formatGeolocation(lat?: number | null, lon?: number | null): string {
    if (lat == null || lon == null) return '-'
    return `${toDMS(lat, 'N', 'S')} and ${toDMS(lon, 'E', 'W')}`
}

export function formatContactName(contact: SiteContactData): string {
    return [contact.salutation, contact.firstName, contact.lastName]
        .filter(Boolean)
        .join(' ') || '-'
}

export function resolveFieldValue(
    dataKey: string,
    siteData: SiteDetailsResponse | null,
    hasApiError: boolean,
): string {
    if (hasApiError || !siteData) return '-'
    if (dataKey === 'geolocation') return formatGeolocation(siteData.latitude, siteData.longitude)
    const val = siteData[dataKey]
    if (val == null || val === '') return '-'
    if (typeof val === 'string') return val
    if (typeof val === 'number' || typeof val === 'boolean') return String(val)
    try {
        return JSON.stringify(val)
    } catch {
        return '-'
    }
}
